<template>
  <div class="footer">
    <div class="footer__main">
      <div class="footer__info">

        <ul class="address">
          <li class="address__item">杨老师 - 咨询QQ：2066256114 &nbsp;  电话：17715258680 </li>
        </ul>

        <ul class="address">
          <li class="address__item">徐老师 - 咨询QQ：246727078 &nbsp;&nbsp;   电话：15366079502</li>
        </ul>

        <ul class="address">
          <li class="address__item">工作时间：周一至周五 9:00-18:00</li>
        </ul>

        <div class="copy-right">
          © 2019-{{ data.currentYear }} 新境（南京）科技有限公司
          <span class="num" @click="openLink('https://beian.miit.gov.cn/#/Integrated/index')">
            苏ICP备2022035091号
          </span>
          <span class="line"></span>
          <span class="num link">
            <img src="@/assets/img/jinghui.png" class="num__icon">
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=32010202011764"
              rel="noreferrer"
              target="_blank"
              class="num__label"
            >
              苏公网安备32010202011764
            </a>
          </span>
        </div>

      </div>

      <div class="footer__qrCode">
        <div class="cover"></div>
        <div>微信扫一扫，关注 “i云课堂”</div>
        <div>手机端登录学习</div>
      </div>

    </div>
  </div>
</template>
<script>
import { reactive } from 'vue'
export default {
  name: 'Footer',
  setup() {
    let data = reactive({
      currentYear: new Date().getFullYear(),
    })

    // 跳转外部网页
    function openLink(url) {
      window.open(url)
    }

    return {
      data,
      openLink
    }
  },
}
</script>
<style lang="less" scoped>
.footer {
  background: lighten(#14181a, 5%);
  color: #999;
  font-size: 14px;
  line-height: 1.15;
  height: 260px;
  overflow: hidden;

  &__main {
    margin: 40px auto 0;
    display: flex;
    width: 1180px;
  }

  &__info {
    padding-top: 20px;
    flex: 1;
    .company {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      &__logo {
        width: 50px;
        height: 50px;
        background: url('../assets/img/logo.jpg') no-repeat center center;
        background-size: cover;
        border-radius: 4px;
        margin-right: 10px;
      }

      &__name {
        flex: 1;
        .name {
          color: #ddd;
          font-size: 18px;
          font-weight: bold;
          margin: 0 0 5px 0;
        }
      }
    }

    .address {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      &__item {
        margin-right: 30px;
      }
    }
  }

  &__qrCode {
    width: 200px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .cover {
      width: 150px;
      height: 150px;
      margin-bottom: 10px;
      background: url('../assets/img/sprite_down.png') 0px 0px no-repeat;
    }
  }

  .copy-right{
    display: flex;
    align-items: center;

    .num{
      margin-left: 15px;
      cursor: pointer;
      transition: all .2s;

      &:hover{
        color: #ddd;
      }

      &.link{
        display: flex;
        align-items: center;
      }

      &__icon{
        width: 20px;
        height: 20px;
        margin-right: 3px;
      }

      a{
        color: #999;
        &:hover{
          color: #ddd;
        }
      }
    }
  }
}

// 屏幕宽度小于 900
@media screen and (max-width: 1180px) {
  .footer {
    line-height: 1.5;
    height: auto;
    padding: 0 20px 30px;
    &__main {
      .absoluteCenter();
      flex-direction: column;
      width: 100%;
    }

    &__info {
      .address {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        &__item{
          margin-right: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }

    &__qrCode {
      margin: 20px 0 0;
    }

    .copy-right{
      flex-direction: column;
    }
  }
}
</style>